import React, { useState } from "react";

import {toast} from "react-hot-toast"

import { useNavigate } from "react-router-dom";


function GOCcspage() {




const reviewOptions = [
  "GarageOnCall fixed my bike perfectly—super reliable service!",
  "Really impressed with GarageOnCall, quick and clean bike repair.",
  "My bike rides smoother than ever, thanks to GarageOnCall.",
  "GarageOnCall came right on time and solved the issue effortlessly.",
  "Excellent bike repair experience with GarageOnCall, very professional.",
  "GarageOnCall’s team knows their work well—fast and trustworthy.",
  "Great doorstep repair by GarageOnCall, hassle-free and efficient.",
  "GarageOnCall made the whole repair process easy and convenient.",
  "Affordable, quality bike repair from GarageOnCall—highly satisfied!"
];



  const [selectedReview, setSelectedReview] = useState("");


  const [loading , setLoading] = useState(false);

  const navigate = useNavigate();

  const [data, setData] = useState({
    customerName: "",
    customerNumber: "",
    servicesName: "",
    serviceDate: "",
    ratingNumber: 0,
    ratingMessage: "",
    userType:"user"
  });

  const seckey = process.env.REACT_APP_REV_KEY;
  const apiUrl = process.env.REACT_APP_API_URL;

  const [hoverStar, setHoverStar] = useState(0);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };


    const handleSelectReview = (review) => {
    setData({
      ...data,
      ratingMessage: review
    });
  };




  const submitForm = async (e) => {
    e.preventDefault();

if (data.customerNumber && data.customerNumber.length != 10) {
  alert("Invalid Number");
  return;
}else if(data.ratingNumber === 0){
  alert("Please select rating");
  return
} else{

setLoading(true)

    try {
      const response = await fetch(`${apiUrl}/auth/post-goc-review`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "seckey":seckey
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();
  
    if(response.ok){

        // toast.success(result.message)
      navigate("/thanks-feedback")

          setData({
      customerName: "",
      customerNumber: "",
      servicesName: "",
      serviceDate: "",
      ratingNumber: 0,
      ratingMessage: "",
      userType: "user"
    });


      }else{
        toast.error(result.message)
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false)
  }

  };

  return (
    <div>
      <div className="glazma-cs-page-bg">
        <div className="glazma-cs-page-main">
          <div className="glazma-cs-page-content">
            <form onSubmit={submitForm}>
              <div className="glazma-cs-page-main-content">
                <h2>Leave a review</h2>

                <div className="custome-rev-fill-input-row">
                  <div className="custome-rev-fill-input-col">
                    <input
                      name="customerName"
                      value={data.customerName}
                      onChange={handleChange}
                      placeholder="Enter your Name"
                      required
                    />
                  </div>

                  <div className="custome-rev-fill-input-col">
                    <input
                      name="customerNumber"
                      value={data.customerNumber}
                      onChange={handleChange}
                      placeholder="Enter your Number (Optional)"
                    />
                  </div>
                </div>

                {/* ROW 2 */}
                <div className="custome-rev-fill-input-row">
                  <div className="custome-rev-fill-input-col">
                    <input
                      name="servicesName"
                      value={data.servicesName}
                      onChange={handleChange}
                      placeholder="Enter Service Name"
                      required
                    />
                  </div>

                  <div className="custome-rev-fill-input-col">
                    <input
                      type="date"
                      name="serviceDate"
                      value={data.serviceDate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>


                        <div className="review-msg-box">
           <label>Select Review</label>
      {reviewOptions.map((review, index) => (
        <div className="msg-option" key={index}>
          <input
            type="radio"
            id={`r${index + 1}`}
            name="review"
            value={review}
            checked={data.ratingMessage === review}
            onChange={() => handleSelectReview(review)}
          />
          <label htmlFor={`r${index + 1}`} className="msg-bubble">
            {review}
          </label>
        </div>
      ))}

            </div>



  {/* STAR RATING */}
                <div className="custome-rev-fill-input-row">
                  <h4>Click the stars to rate us*</h4>
                </div>

                 <div className="custome-rev-fill-input-row-start">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={
                        star <= (hoverStar || data.ratingNumber)
                          ? "fa-solid fa-star"
                          : "fa-regular fa-star"
                      }
                      style={{ cursor: "pointer", color: "#FFD700", fontSize: 25 }}
                      onMouseEnter={() => setHoverStar(star)}
                      onMouseLeave={() => setHoverStar(0)}
                      onClick={() => setData({ ...data, ratingNumber: star })}
                    ></i>
                  ))}
                </div>


                {/* MESSAGE */}
                <div className="custome-rev-fill-message-row">
                  <label>Review*</label>
                  <textarea
                    name="ratingMessage"
                    value={data.ratingMessage}
                    onChange={handleChange}
                    rows={7}
                    required
                  ></textarea>
                </div>

                {/* SUBMIT BUTTON */}
                <div className="custome-rev-fill-message-row">
                  <button type="submit">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GOCcspage;

// export default GOCcspage 